<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
      size="small"
      fit
      row-key="Id"
      ><el-table-column label="小程序码" width="80">
        <template slot-scope="scope">
          <el-button
            type="info"
            icon="fa fa-qrcode"
            size="small"
            @click="openQrCode(scope.row.Eid)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column label="活动主题" prop="Name">
        <template slot-scope="scope">{{ field(scope.row.Name) }}</template>
      </el-table-column>
      <el-table-column label="地址" width="370">
        <template slot-scope="scope"
          >/pages/activity/themeActivity?id={{ scope.row.Eid }}</template
        >
      </el-table-column>
      <el-table-column prop="Enabled" label="状态" width="65">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Enabled ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Enabled ? "正常" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Remark')"
        prop="Remark"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="创建时间" prop="Created" width="150">
        <template slot-scope="scope">{{
          formatDateTime(scope.row.Created)
        }}</template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="150px" ref="addForm" size="small">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input
                v-model="addForm.Name[slot.langkey]"
                style="width: 195px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="背景图"
              :prop="'BgImage.' + slot.langkey"
              :rules="{
                required: true,
                message: '请上传背景图片',
                trigger: 'change',
              }"
            >
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="
                    (file, fileList) => {
                      bgImgHandleChange(file, fileList, slot.langkey);
                    }
                  "
                  :style="{
                    backgroundImage:
                      'url(' + addForm.BgImage[slot.langkey] + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!addForm.BgImage[slot.langkey]"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="addForm.BgImage[slot.langkey]"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!addForm.BgImage[slot.langkey]"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    上传照片
                  </div>
                  <div
                    v-show="addForm.BgImage[slot.langkey]"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    重新选择
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item
              label="距离顶部"
              prop="FromTop"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '距离顶部',
              }"
            >
              <el-input
                v-model.number="addForm.FromTop"
                style="width: 195px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="背景色"
              prop="BgColor"
              :rules="{ required: true, message: $t('pleaseEnter') + '背景色' }"
            >
              <el-color-picker v-model="addForm.BgColor"></el-color-picker>
            </el-form-item>
            <el-form-item
              label="分享标题"
              prop="ShareTitle"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '分享标题',
              }"
            >
              <el-input v-model="addForm.ShareTitle"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('ShareCover')"
              prop="ShareCover"
              :rules="{
                required: true,
                message: '请上传分享图片',
                trigger: 'change',
              }"
            >
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="handleShareChange"
                  :style="{
                    backgroundImage: 'url(' + addForm.ShareCover + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!addForm.ShareCover"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="addForm.ShareCover"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!addForm.ShareCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="addForm.ShareCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item
              label="商户"
              prop="ShopIds"
              :rules="{ required: true, message: $t('pleaseEnter') + '商户' }"
            >
              <el-select
                v-model="addForm.ShopIds"
                filterable
                remote
                clearable
                placeholder="请输入关键词"
                :remote-method="shopRemoteMethod"
                :loading="selectShoploading"
                multiple
                style="width: 400px"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.Id"
                  :label="field(item.Name)"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内部备注">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                v-model="addForm.Remark"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-switch v-model="addForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="addForm.Name[slot.item.key]"></el-input>
            </el-form-item>
            <el-form-item label="背景图">
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="
                    (file, fileList) => {
                      bgImgHandleChange(file, fileList, slot.item.key);
                    }
                  "
                  :style="{
                    backgroundImage:
                      'url(' + addForm.BgImage[slot.item.key] + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!addForm.BgImage[slot.item.key]"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="addForm.BgImage[slot.item.key]"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!addForm.BgImage[slot.item.key]"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    上传照片
                  </div>
                  <div
                    v-show="addForm.BgImage[slot.item.key]"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    重新选择
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--修改-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        :model="editForm"
        label-width="150px"
        ref="editForm"
        size="small"
      >
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.' + slot.langkey"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + $t('Name'),
              }"
            >
              <el-input
                v-model="editForm.Name[slot.langkey]"
                style="width: 195px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="背景图"
              :prop="'EditBgImage.' + slot.langkey"
              :rules="{
                required: true,
                message: '请上传背景图片',
                trigger: 'change',
              }"
            >
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="
                    (file, fileList) => {
                      upbgImgHandleChange(file, fileList, slot.langkey);
                    }
                  "
                  :style="{
                    backgroundImage:
                      'url(' +
                      baseBgImageUrl[slot.langkey] +
                      editForm.EditBgImage[slot.langkey] +
                      ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!editForm.EditBgImage[slot.langkey]"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="editForm.EditBgImage[slot.langkey]"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!editForm.EditBgImage[slot.langkey]"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    上传照片
                  </div>
                  <div
                    v-show="editForm.EditBgImage[slot.langkey]"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    重新选择
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item
              label="距离顶部"
              prop="FromTop"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '距离顶部',
              }"
            >
              <el-input
                v-model.number="editForm.FromTop"
                style="width: 195px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="背景色"
              prop="BgColor"
              :rules="{ required: true, message: $t('pleaseEnter') + '背景色' }"
            >
              <el-color-picker v-model="editForm.BgColor"></el-color-picker>
            </el-form-item>
            <el-form-item
              label="分享标题"
              prop="ShareTitle"
              :rules="{
                required: true,
                message: $t('pleaseEnter') + '分享标题',
              }"
            >
              <el-input v-model="editForm.ShareTitle"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('ShareCover')"
              prop="EditShareCover"
              :rules="{
                required: true,
                message: '请上传分享图片',
                trigger: 'change',
              }"
            >
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="uphandleShareChange"
                  :style="{
                    backgroundImage:
                      'url(' +
                      baseShareCoverUrl +
                      editForm.EditShareCover +
                      ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!editForm.EditShareCover"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="editForm.EditShareCover"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!editForm.EditShareCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadImgLabel") }}
                  </div>
                  <div
                    v-show="editForm.EditShareCover"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    {{ $t("uploadChoose") }}
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item
              label="商户"
              prop="ShopIds"
              :rules="{ required: true, message: $t('pleaseEnter') + '商户' }"
            >
              <el-select
                v-model="editForm.ShopIds"
                filterable
                remote
                clearable
                placeholder="请输入关键词"
                :remote-method="shopRemoteMethod"
                :loading="selectShoploading"
                multiple
                style="width: 400px"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.Id"
                  :label="field(item.Name)"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内部备注">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                v-model="editForm.Remark"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-switch v-model="editForm.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="editForm.Name[slot.item.key]"></el-input>
            </el-form-item>
            <el-form-item label="背景图">
              <div class="upload-img-form">
                <el-upload
                  class="upload-img"
                  :auto-upload="false"
                  action="xxx"
                  list-type="picture"
                  :show-file-list="false"
                  :on-change="
                    (file, fileList) => {
                      upbgImgHandleChange(file, fileList, slot.item.key);
                    }
                  "
                  :style="{
                    backgroundImage:
                      'url(' +
                      baseBgImageUrl[slot.item.key] +
                      editForm.EditBgImage[slot.item.key] +
                      ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain',
                  }"
                  accept="image/png, image/gif, image/jpg, image/jpeg"
                >
                  <i
                    v-show="!editForm.EditBgImage[slot.item.key]"
                    class="el-icon-upload avatar-uploader-icon"
                  ></i>
                  <i
                    v-show="editForm.EditBgImage[slot.item.key]"
                    class="el-icon-refresh avatar-uploader-icon"
                  ></i>
                  <div
                    v-show="!editForm.EditBgImage[slot.item.key]"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    上传照片
                  </div>
                  <div
                    v-show="editForm.EditBgImage[slot.item.key]"
                    slot="tip"
                    class="el-upload__text upload__tip"
                  >
                    重新选择
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
    <!--二维码-->
    <el-dialog
      title="小程序码"
      :visible.sync="qrCodeVisible"
      v-model="qrCodeVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="imgdiv">
        <el-image class="imgqrcode" :src="qrCodeSrc" lazy
          ><div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i></div
        ></el-image>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="qrCodeVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import {
  getThemeActivityList,
  removeThemeActivity,
  editThemeActivity,
  addThemeActivity,
  getShopList,
  getShopListByIds,
  base,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      baseBgImageUrl: this.langDefaultVal,
      baseShareCoverUrl: base + "/FileUpload/ThemeActivityImage/a0/",
      filters: {
        Name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      currentRow: null,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: { EditBgImage: {}, BgImageFileXml: {} },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {},
      shopList: [],
      selectShoploading: false,
      qrCodeVisible: false,
      qrCodeUrl: base + "/admin/ThemeActivity/GetQRCodeImage?id=",
      qrCodeSrc: "",
    };
  },
  methods: {
    openQrCode(id) {
      this.qrCodeSrc = this.qrCodeUrl + id;
      this.qrCodeVisible = true;
    },
    shopRemoteMethod(query) {
      if (query !== "") {
        let para = {
          key: query,
        };
        this.selectShoploading = true;
        getShopList(para).then((res) => {
          this.shopList = res.data.response.data;
          this.selectShoploading = false;
        });
      } else {
        this.shopList = [];
      }
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    // 分享图片预览
    uphandleShareChange(file) {
      this.baseShareCoverUrl = "";
      this.editForm.EditShareCover = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.ShareCoverFile = res;
      });
      this.$refs.editForm.validateField("EditShareCover");
    },
    handleShareChange(file) {
      this.addForm.ShareCover = file.url;
      this.getBase64(file.raw).then((res) => {
        this.addForm.ShareCoverFile = res;
      });
      this.$refs.addForm.validateField("ShareCover");
    },
    // 背景图预览
    bgImgHandleChange(file, filelist, key) {
      this.addForm.BgImage[key] = file.url;
      this.getBase64(file.raw).then((res) => {
        this.addForm.BgImageFileXml[key] = res;
      });
      this.$refs.addForm.validateField("BgImage." + key);
    },
    upbgImgHandleChange(file, filelist, key) {
      this.baseBgImageUrl[key] = "";
      this.editForm.EditBgImage[key] = file.url;
      this.getBase64(file.raw).then((res) => {
        this.editForm.BgImageFileXml[key] = res;
      });
      this.$refs.editForm.validateField("EditBgImage." + key);
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    formatDateTime: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取列表
    getList() {
      let _this = this;

      let para = {
        key: this.filters.Name,
        page: this.page,
      };
      this.listLoading = true;
      getThemeActivityList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeThemeActivity(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editForm = Object.assign(
        { EditBgImage: {}, BgImageFileXml: {} },
        this.clone(row)
      );
      
      if (!util.isEmt.format(this.editForm.ShopIds)) {
        getShopListByIds({ ids: this.editForm.ShopIds.join(",") }).then(
          (res) => {
            this.shopList = res.data.response;
          }
        );
      }
      
      this.editForm.EditBgImage = this.editForm.BgImage;
      this.editForm.EditShareCover = this.editForm.ShareCover;
      Object.keys(this.langDefaultVal).forEach((key) => {
        this.baseBgImageUrl[key] =
          this.editForm.EditBgImage[key] != ""
            ? base + "/FileUpload/ThemeActivityImage/a0/"
            : "";
      });
      
      this.baseShareCoverUrl = base + "/FileUpload/ThemeActivityImage/a0/";
      this.editFormVisible = true;
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Name: {},
        ShopIds: [],
        Value: 0,
        BgImage: this.langDefaultVal,
        BgImageFileXml: {},
        FromTop: 200,
        BgColor: "",
        ShareCover: "",
        ShareCoverFile: "",
        Enabled: true,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);

              editThemeActivity(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              para.IsDeleted = false;

              addThemeActivity(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }

                if (res.data.success) {
                  this.addLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
  },
  mounted() {
    this.getList();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>